import { Box, Grid, Link, Stack, Typography } from '@mui/material';
import construction from 'assets/images/maintenance/under-construction.svg';
import { UNDER_CONSTRUCTION_START_TIME, UNDER_CONSTRUCTION_END_TIME } from 'config';

const underConstructionStartTime = UNDER_CONSTRUCTION_START_TIME;
const underConstructionEndTime = UNDER_CONSTRUCTION_END_TIME;
const supportEmail = 'support@lexis.tech';

const UnderConstruction = () => {
    return (
        <Grid
            container
            spacing={4}
            direction='column'
            alignItems='center'
            justifyContent='center'
            sx={{ minHeight: '100vh', py: 2 }}>
            <Grid item xs={12}>
                <Box sx={{ width: { xs: 300, sm: 480 } }}>
                    <img src={construction} alt='mantis' style={{ width: '100%', height: 'auto' }} />
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Stack spacing={5} justifyContent='center' alignItems='center'>
                    <Typography align='center' variant='h1'>
                        Under Construction
                    </Typography>
                    <Typography color='textSecondary' align='center' sx={{ width: '85%' }}>
                        Hey! Please check out this site later. We are doing some maintenance on it right now.
                    </Typography>
                    <ConstructionTimeDisplay
                        startTime={underConstructionStartTime}
                        endTime={underConstructionEndTime}
                    />
                    <Typography variant='body2' color='textSecondary' sx={{ mt: 2 }}>
                        If you need immediate assistance, please contact us at:{' '}
                        <Link href={`mailto:${supportEmail}`} color='primary'>
                            {supportEmail}
                        </Link>
                    </Typography>
                </Stack>
            </Grid>
        </Grid>
    );
};

const ConstructionTimeDisplay = ({ startTime, endTime }) => {
    return (
        <Stack spacing={1} alignItems='center' sx={{ mt: 2, p: 2, backgroundColor: 'grey.200', borderRadius: '8px' }}>
            <Typography variant='subtitle1' component='div' sx={{ fontWeight: 'medium' }}>
                Maintenance Window:
            </Typography>
            {startTime && (
                <Typography variant='body2' color='textSecondary'>
                    <strong>Starts:</strong> {startTime}
                </Typography>
            )}
            {endTime && (
                <Typography variant='body2' color='textSecondary'>
                    <strong>Ends:</strong> {endTime}
                </Typography>
            )}
            {!startTime && !endTime && (
                <Typography variant='body2' color='textSecondary'>
                    Maintenance times will be updated soon.
                </Typography>
            )}
        </Stack>
    );
};

export default UnderConstruction;
